<template>
  <section class="slide">
    <swiper
      :modules="modules"
      :slides-per-view="1"
      :space-between="0"
      :loop="true"
      :autoplay="{
        delay: 5000,
        disableOnInteraction: false
      }"
      :scrollbar="{ draggable: true }"
    >
      <swiper-slide v-for="item in campaigns.slice(0, 3)" :key="item.id">
        <div class="swiper-slide hero-content-wrap">
          <img
            :src="getImageSource(item.BACKGROUND_PATH)"
            alt="Campaign Background"
            class="campaign-background"
          />
          <div class="hero-content-overlay position-absolute w-100 h-100">
            <div class="container h-100">
              <div class="row h-100">
                <div
                  class="col-12 col-lg-8 d-flex flex-column justify-content-center align-items-start"
                >
                  <header class="entry-header">
                    <span class="campaign-detail title-text">
                      <a :href="'/about-campaign/' + item.ID">
                        {{ item.TITLE }}
                      </a>
                    </span>
                  </header>
                  <footer class="entry-footer d-flex flex-wrap align-items-center mt-5">
                    <a :href="'/about-campaign/' + item.ID" class="btn gradient-bg mr-2">รายละเอียด</a>
                  </footer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </section>
</template>

<script setup>
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { useCampaigns } from './scripts/useCampaigns';

const backend_url = import.meta.env.VITE_API_URL;
const { Campaigns: campaigns } = useCampaigns();

const modules = [Navigation, Scrollbar, Pagination, A11y, Autoplay];

const getImageSource = (backgroundPath) => {
  if (backgroundPath === '') {
    return `${backend_url}/images/hero.jpg`;
  } else {
    return backend_url + backgroundPath;
  }
};
</script>

<style scoped>
@media (min-width: 1400px) {
  .container {
    max-width: 1140px;
  }
  .campaign-background {
    max-height: 600px;
  }
}

@media (min-width: 1280px) {
  .title-text {
    font-size: 80px;
  }
}

@media (min-width: 1025px) and (max-width: 1279px) {
  .title-text {
    font-size: 8vw;
  }
}

@media (min-width: 680px) and (max-width: 1024px) {
  .title-text {
    font-size: 7vw;
  }
}

@media (max-width: 420px) {
  .title-text {
    font-size: 7vw;
  }
}

.campaign-detail > a:link,
a:visited,
a:hover {
  text-decoration: none;
  color: white;
}
</style>